/* @jsx h */
import { h } from "preact";
import { useState, useEffect, useCallback, useRef } from "preact/hooks";
import { useChecklistContext } from "../../context";
import { checklistSyncError, DEBOUNCE_AUTOSAVE_DELAY_MS } from "../../constants";
import { putUserCheckedItems } from "../../api";
import Text from "@ingka/text";

function Autosave() {
    const { userToken, userCheckedItems, autosaveError, setAutosaveError, logOutUser } = useChecklistContext();
    const [status, setStatus] = useState(null);
    const lastSaved = useRef(JSON.stringify([...userCheckedItems]));

    const debounce = (func, timeout = 600) => {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, timeout);
        };
    };

    const debouncedSave = useCallback(
        debounce(async (updatedString) => {
            const { success, error } = await putUserCheckedItems(userToken, updatedString);
            if (success) {
                setStatus(
                    `Last saved at ${new Date().toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit"
                    })}`
                );
                lastSaved.current = updatedString;
                return;
            }
            if (error === 401) return logOutUser();
            // @todo potentially set catastrophic error (500) here, if server is completely down and we don't want 
            // user to access checklist at all?
            setAutosaveError(checklistSyncError);
        }, DEBOUNCE_AUTOSAVE_DELAY_MS),
        []
    );

    useEffect(() => {
        const updatedString = JSON.stringify([...userCheckedItems]);
        if (updatedString !== lastSaved.current) {
            setAutosaveError(null);
            setStatus("Saving...");
            debouncedSave(updatedString);
        }
    }, [userCheckedItems, debouncedSave]);

    return (
        <Text className="checklist-save-status" tagName="h4" headingSize="s">
            {autosaveError ? autosaveError : status}
        </Text>
    );
}

export default Autosave;
